import { staticURL } from 'core/url';
import React from 'react';
import { formatDate } from 'utils/formatStrings';

type CanceledPlanDescriptionProps = {
  canceledData: string | Date;
  status: string;
};

export const CanceledPlanDescription = ({
  canceledData,
  status,
}: CanceledPlanDescriptionProps) => {
  const canceledDate = formatDate(canceledData, 'dd/MM/yyyy');
  const isCanceled = status === 'CANCELED';

  return (
    <p
      className='flex flex-end text-orange-500'
      data-testid='canceledPlanDescription-text'
    >
      <img src={staticURL('assets/icons/info.svg')} alt='plan description' />
      {isCanceled
        ? `Your plan has been cancelled on ${canceledDate}`
        : `Your plan will be cancelled on ${canceledDate}`}
    </p>
  );
};
